<template>
  <!-- PC 端内容介绍, 纯 UI 组件 -->
  <section class="product-list-container" v-if="productList.length">
    <div class="product-item-container" v-for="(productItem, idx) in productList" :key="idx">
      <div class="product-item-info">
        <div class="product-item-title">{{ productItem.title }}</div>
        <div class="product-item-sub-title">{{ productItem.subTitle }}</div>
        <div class="product-item-content-list">
          <div
            v-for="(contentItem, idy) in productItem.content"
            :key="idy"
            class="product-item-content"
          >
            {{ contentItem.paragraph }}
          </div>
        </div>
        <div
          class="button-container"
          v-if="productItem.qrCode"
          ref="buttonContainerRef"
          @mouseenter="showQrCode(idx, productItem.title)"
          @mouseleave="hideQrCode(idx)"
        >
          <div class="button">立即体验</div>
          <p-qr-code-float
            v-if="showQrCodeIdList.includes(idx)"
            class="qrcode-float-container"
            :title="productItem.qrCodeIntroTip"
            :qrCode="productItem.qrCode"
          />
        </div>
      </div>
      <div class="product-media-container">
        <div class="video-container" v-if="productItem.introMedia.type === 'video'">
          <video
            :src="productItem.introMedia.link"
            :poster="productItem.introMedia.coverImageUrl"
            controls
          ></video>
        </div>
        <div class="image-container" v-if="productItem.introMedia.type === 'image'">
          <img :src="productItem.introMedia.link | img2WebpFilter" alt="" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    productList: {
      type: Array,
      default: () => []
    },
    frogPath: {
      type: String,
      default: ''
    },
    pageType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showQrCodeIdList: []
    }
  },
  methods: {
    showQrCode(idx, title) {
      this.showQrCodeIdList = [idx]
      this.sendEvent(title)
    },
    hideQrCode() {
      this.showQrCodeIdList = []
    },
    sendEvent(subjectName) {
      const commonParams = [
        { key: 'devicetype', value: 'pc' },
        { key: 'pageType', value: this.pageType },
        { key: 'package', value: subjectName }
      ]
      this.$addFrog(this.frogPath, commonParams)
    }
  }
}
</script>

<style lang="less" scoped>
.product-list-container {
  box-sizing: border-box;
  padding: 128px 80px 128px;
  width: 100%;
  min-width: 1208px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  .product-item-container {
    display: flex;
    align-items: flex-start;
    justify-content: center;

    &:not(:last-child) {
      margin-bottom: 128px;
    }

    .product-item-info {
      font-family: 'PingFang SC';
      font-style: normal;
      color: #000000;
      flex-shrink: 0;
      width: 720px;
      margin-right: 48px;

      .product-item-title {
        font-weight: 600;
        font-size: 32px;
        line-height: 46px;
        margin-bottom: 32px;
      }

      .product-item-sub-title {
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
        color: #19b2ff;
        margin-bottom: 16px;
      }

      .product-item-content-list {
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        color: #000000;
        text-align: justify;

        .product-item-content {
          &:not(:last-child) {
            margin-bottom: 16px;
          }
        }
      }

      .button-container {
        margin-top: 32px;
        position: relative;
        width: 200px;
        height: 56px;
        background: #00cc66;
        border-radius: 100px;
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;

        .qrcode-float-container {
          position: absolute;
          right: -188px;
          box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.08);
        }
      }
    }

    .product-media-container {
      width: 360px;
      font-size: 0;
      flex-shrink: 0;

      .image-container {
        width: 100%;
        border-radius: 8px;
        overflow: hidden;

        img {
          width: 100%;
        }
      }

      .video-container {
        width: 100%;
        border-radius: 8px;
        overflow: hidden;

        video {
          width: 100%;
        }
      }
    }
  }
}
</style>
